import { cx } from './cx';
import { fsClass } from '@/styles/typography';

export interface QuickAmountChipsProps {
  amounts?: number[];
  value?: number | null;
  onSelect: (amount: number) => void;
  className?: string;
}

/** Cosmos quick-amount chips (1d): $10 / $25 / $50 / $100 presets. */
export default function QuickAmountChips({
  amounts = [10, 25, 50, 100],
  value,
  onSelect,
  className,
}: QuickAmountChipsProps) {
  return (
    <div className={cx('flex flex-wrap gap-2', className)}>
      {amounts.map((amt) => {
        const active = value === amt;
        return (
          <button
            key={amt}
            type="button"
            onClick={() => onSelect(amt)}
            className={cx(
              'h-9 px-4 rounded-full font-money font-semibold tabular-nums transition-all duration-150',
              fsClass.base,
              'border focus-visible:outline-none focus-visible:shadow-focus-ring',
              active
                ? 'bg-gradient-to-b from-money-out-soft to-money-out text-on-money-out border-white/25 shadow-glow-gold'
                : 'bg-white/5 text-ice border-border-ice hover:bg-white/10 hover:text-ink',
            )}
          >
            ${amt}
          </button>
        );
      })}
    </div>
  );
}
